<template>
  <div class="main-menu-skeleton-wrapper">
    <nav v-if="isLoading" class="side-menu-skeleton">
      <ul class="side-menu-skeleton-list">
        <li class="side-menu-skeleton-list__item" v-for="i in itemsCount" :key="i">
          <div class="side-menu-skeleton-button">
            <div class="side-menu-skeleton-icon skeleton-block"></div>
            <div class="side-menu-skeleton-text skeleton-block"></div>
          </div>
        </li>
      </ul>
    </nav>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    itemsCount: {
      type: Number,
      default: 5
    }
  }
};
</script>

<style lang="scss" scoped>
.side-menu-skeleton {
  &-list {
    &__item {
      &:nth-child(n+2) {
        margin-top: 8px;
      }
    }
  }

  &-button {
    position: relative;
    display: block;
    margin: 0 16px;
    padding: 22px 0;
    background-color: white;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
  }

  &-icon {
    width: 24px;
    height: 24px;
    margin: 0 auto 8px;
    border-radius: 50%;
  }

  &-text {
    width: 60%;
    height: 14px;
    margin: 0 auto;
    border-radius: 4px;
  }
}

.skeleton-block {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
